import { render, staticRenderFns } from "./spam.vue?vue&type=template&id=3ed59a6c&scoped=true&"
import script from "./spam.vue?vue&type=script&lang=js&"
export * from "./spam.vue?vue&type=script&lang=js&"
import style1 from "./spam.vue?vue&type=style&index=1&id=3ed59a6c&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed59a6c",
  null
  
)

export default component.exports